import { useState } from "react";
import axiosInstance from "../utils/axiosInstance";

const WHATSAPP_NUMBER = "919182729720"; // country code + number, no +
const WHATSAPP_MESSAGE = "Hello! I found your contact on the website and would like to get in touch.";

export default function GetInTouch() {
  const [formData, setFormData] = useState({ name: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", msg: "" });

  const openWhatsApp = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.message) {
      setStatus({ type: "error", msg: "Please fill all fields." });
      return;
    }
    setLoading(true);
    setStatus({ type: "", msg: "" });
    try {
      await axiosInstance.post("/api/contacts", formData);
      setStatus({ type: "success", msg: "Message sent successfully! We will contact you soon." });
      setFormData({ name: "", phone: "", message: "" });
    } catch (error) {
      setStatus({ type: "error", msg: "Failed to send message. Please try again later." });
    } finally {
      setLoading(false);
    }
  };

  const contactItems = [
    {
      key: "phone",
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      ),
      label: "Phone",
      value: "+91 9182729720",
      href: "tel:+919182729720",
    },
    {
      key: "email",
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      label: "Email",
      value: "info@mysun.in",
      href: "mailto:info@mysun.in",
    },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .git-section {
          min-height: 100vh;
          background: #fdfdfc;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 80px 20px;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        .git-container {
          max-width: 1200px;
          width: 100%;
          display: grid;
          grid-template-columns: 1.1fr 0.9fr;
          gap: 80px;
        }

        /* LEFT SIDE */
        .git-left { display: flex; flex-direction: column; gap: 40px; }

        .git-heading-wrap { max-width: 500px; }
        .git-heading {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: clamp(32px, 5vw, 48px);
          font-weight: 800;
          color: #1a1a1a;
          line-height: 1.1;
          letter-spacing: -2px;
          margin-bottom: 20px;
        }
        .git-sub { font-size: 16px; color: #555; line-height: 1.6; }

        .git-form-box {
          background: #fff;
          padding: 40px;
          border-radius: 24px;
          border: 1px solid rgba(0,0,0,0.06);
          box-shadow: 0 10px 40px rgba(0,0,0,0.04);
        }

        .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; }
        .input-wrap { display: flex; flex-direction: column; gap: 8px; }
        .input-wrap.full { grid-column: span 2; }
        
        .label { font-size: 13px; font-weight: 600; color: #666; letter-spacing: 0.5px; }
        .input, .textarea {
          width: 100%;
          padding: 14px 18px;
          border-radius: 12px;
          border: 1.5px solid #eee;
          background: #f9f9f9;
          font-family: inherit;
          font-size: 15px;
          transition: all 0.2s;
          outline: none;
        }
        .input:focus, .textarea:focus {
          background: #fff;
          border-color: #1ECCB0;
          box-shadow: 0 0 0 4px rgba(30,204,176,0.1);
        }
        .textarea { height: 120px; resize: none; }

        .submit-btn {
          width: 100%;
          padding: 16px;
          border: none;
          border-radius: 12px;
          background: #1a1a1a;
          color: #fff;
          font-weight: 700;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        .submit-btn:hover:not(:disabled) { background: #000; transform: translateY(-1px); box-shadow: 0 5px 15px rgba(0,0,0,0.1); }
        .submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        .status-msg { margin-top: 15px; padding: 12px; border-radius: 8px; font-size: 14px; text-align: center; }
        .status-msg.success { background: #e6fffa; color: #14746f; border: 1px solid #b2f5ea; }
        .status-msg.error { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }

        /* RIGHT SIDE */
        .git-right { display: flex; flex-direction: column; gap: 30px; }

        .info-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
        .info-card {
           padding: 24px; background: #fff; border-radius:20px; border: 1px solid #eee;
           text-decoration: none; transition: 0.2s;
        }
        .info-card:hover { border-color: #1ECCB0; transform: translateY(-3px); }
        .icon-circle { 
           width: 44px; height: 44px; border-radius: 12px; background: #f0fdfb; 
           display: grid; place-items: center; color: #1ECCB0; margin-bottom: 15px;
        }

        .map-section { border-radius: 20px; overflow: hidden; border: 1px solid #eee; flex: 1; min-height: 450px; }
        .map-section iframe { width: 100%; height: 100%; border: 0; }

        /* Mobile */
        @media (max-width: 900px) {
           .git-container { grid-template-columns: 1fr; gap: 40px; }
           .form-grid { grid-template-columns: 1fr; }
           .input-wrap.full { grid-column: auto; }
           .info-cards { grid-template-columns: 1fr; }
        }
      `}</style>

      <section className="git-section">
        <div className="git-container">

          <div className="git-left">
            <div className="git-heading-wrap">
              <h1 className="git-heading">Let's start a conversation.</h1>
              <p className="git-sub">Have a question about the entrepreneur plan or our products? Send us a message and we'll get back to you shortly.</p>
            </div>

            <div className="git-form-box">
              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="input-wrap">
                    <label className="label">FULL NAME</label>
                    <input className="input" name="name" placeholder="Enter Full Name" value={formData.name} onChange={handleInputChange} />
                  </div>
                  <div className="input-wrap">
                    <label className="label">PHONE NUMBER</label>
                    <input className="input" name="phone" placeholder="Enter Phone Number" value={formData.phone} onChange={handleInputChange} />
                  </div>
                  <div className="input-wrap full">
                    <label className="label">MESSAGE</label>
                    <textarea className="textarea" name="message" placeholder="Enter your message..." value={formData.message} onChange={handleInputChange}></textarea>
                  </div>
                </div>

                <button className="submit-btn" type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Send Message"}
                </button>

                {status.msg && <div className={`status-msg ${status.type}`}>{status.msg}</div>}
              </form>
            </div>
          </div>

          <div className="git-right">
            <div className="info-cards">
              {contactItems.map(item => (
                <a key={item.key} href={item.href} className="info-card">
                  <div className="icon-circle">{item.icon}</div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#999', marginBottom: 4 }}>{item.label}</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a' }}>{item.value}</div>
                </a>
              ))}
            </div>

            <div className="map-section">
              <a
                href="https://www.google.com/maps/search/?api=1&query=F.+NO+101,+48-13-17,+Sringar,+Janakirama+street,+Near+RTC+Complex,+Visakhapatnam-16"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', height: '100%', cursor: 'pointer' }}
                title="Click to view on Google Maps"
              >
                <iframe
                  title="location"
                  src="https://maps.google.com/maps?q=F.%20NO%20101,%2048-13-17,%20Sringar,%20Janakirama%20street,%20Near%20RTC%20Complex,%20Visakhapatnam-16&t=&z=16&ie=UTF8&iwloc=&output=embed"
                  allowFullScreen
                  loading="lazy"
                  style={{ pointerEvents: 'none' }}
                ></iframe>
              </a>
            </div>

            <button onClick={openWhatsApp} style={{ background: '#25D366', color: '#fff', border: 'none', padding: '14px', borderRadius: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: '100%' }}>
              <svg style={{ width: 20, height: 20 }} fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-4.821 7.454c-1.879 0-3.715-.506-5.319-1.462l-.382-.228-3.951 1.036 1.055-3.852-.25-.398a12.128 12.128 0 01-1.859-6.426C2.3 5.488 6.66 1.13 12.04 1.13c2.607 0 5.056 1.015 6.899 2.859 1.844 1.844 2.858 4.293 2.858 6.899 0 5.373-4.359 9.733-9.742 9.733" />            </svg>
              Contact on WhatsApp
            </button>
          </div>

        </div>
      </section>
    </>
  );
}